<template>
  <q-page class="stretch-grid">
    <!-- content -->
    <Grid
      class='fit'
      :module="module"
      :data="courseList"
      :columns="columnOptions"
      :onLaunch="select"
      :loading="loadingData"
      :onRequest="fetch"
      :filterable="filterable"
    >
      <template slot="header-item" slot-scope="props">
        {{props.label}}
      </template>
      <template slot="col-item" slot-scope="props">
        {{props.value}}
      </template>
    </Grid>
    <DetailsModal :module="module" v-if="open">
      <template slot="header-options">
        <q-btn-dropdown icon="more vert" v-if="$p(['ADMIN'])">
          <q-list link>
            <q-item @click.native="onRemove()" v-close-overlay>
              <q-item-main>
                <q-item-tile label><q-icon name="fa fa-trash" color="red" /> Delete Course</q-item-tile>
              </q-item-main>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </template>
    </DetailsModal>
    <q-layout-footer>
      <q-toolbar>
        <q-toolbar-title>
        </q-toolbar-title>
        <q-btn
          label="New Course"
          icon="add"
          color="primary"
          @click="addNew()">
        </q-btn>
      </q-toolbar>
    </q-layout-footer> 
  </q-page>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Grid from '../components/Shared/Grid'
import DetailsModal from '../components/Shared/DetailsModal'

export default {
  name: 'Courses',
  components: {
    Grid,
    DetailsModal
  },
  data () {
    return {
      filterable: true,
      module: this.$route.meta.module,
      columnOptions: [
        { field: 'COURSE_NAME', name: 'COURSE_NAME', label: 'Course Name', sortable: true, filterable: true, type: 'string' },
        { field: 'STATES', name: 'STATES', label: 'State', sortable: false, filterable: true, type: 'string',
          format: states => states.map(state => state.STATE).join(', ') },
        { field: 'COURSE_LENGTH_HOURS', name: 'COURSE_LENGTH_HOURS', label: 'Hours', sortable: true, filterable: true, type: 'number' },
        { field: 'COURSE_LENGTH_MINUTES', name: 'COURSE_LENGTH_MINUTES', label: 'Minutes', sortable: true, filterable: true, type: 'number' },
        { field: 'COURSE_LENGTH_SECONDS', name: 'COURSE_LENGTH_SECONDS', label: 'Seconds', sortable: true, filterable: true, type: 'number' }
      ],
      removeDialogOptions: {
        title: 'Remove Course?',
        message: 'Are you sure you want to remove this course?',
        ok: {
          label: 'Remove',
          color: 'negative'
        },
        cancel: {
          label: 'Cancel'
        }
      }
    }
  },
  computed: {
    ...mapGetters('courses', [
      'courseList'
    ]),
    ...mapState({
      open: state => state.shared.detailsModal.open      
    }),
    ...mapState('courses', {
      loadingData: state => state.loadingData
    })
  },
  methods: {
    ...mapActions('courses', [
      'fetch',
      'select',
      'addNew',
      'exportExcel',
      'remove'
    ]),
    onRemove () {
      this.$q.dialog(this.removeDialogOptions)
      .then(this.remove).catch(err => err)
    },
  }
}
</script>
